// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import store from '@/store'
import api from '@/request/api'
import {
  DatePicker, Icon, Button, Select, Option, Form, FormItem, Input, Checkbox, Dialog, MessageBox, Message, Upload, Table, TableColumn, Pagination, Tooltip, Radio,
  CheckboxButton,
  CheckboxGroup,
  RadioGroup,
  RadioButton,
  Popover,
  Progress,
  Loading
} from 'element-ui';

Vue.prototype.$api = api;

Vue.use(DatePicker)
Vue.use(Icon)
Vue.use(Button)
Vue.use(Select)
Vue.use(Option)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Radio)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Loading)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js